<template>
  <sg-font :tag="tag" v-bind="[colorProps, leadProps, variantProps, primaryProps]">
    <slot />
  </sg-font>
</template>

<script>
export default {
  props: {
    tag: { type: String, default: 'p' },

    large: Boolean,
    regular: Boolean,
    small: Boolean,
    micro: Boolean,

    leadTight: Boolean,
    leadRegular: Boolean,
    leadLoose: Boolean,

    lightNavy: Boolean,
    navy: Boolean,
    darkNavy: Boolean,
    lightGray: Boolean,
    gray: Boolean,
    darkGray: Boolean,
    black: Boolean,
    white: Boolean,
    red: Boolean,

    bold: Boolean,
    center: Boolean,
    ellipsis: Boolean,
    italic: Boolean,
    medium: Boolean,
    underline: Boolean,
    uppercase: Boolean,
  },

  computed: {
    colorProps() {
      if (this.lightNavy) return { lightNavy: true };
      if (this.navy) return { navy: true };
      if (this.darkNavy) return { darkNavy: true };
      if (this.lightGray) return { lightGray: true };
      if (this.gray) return { gray: true };
      if (this.darkGray) return { darkGray: true };
      if (this.black) return { black: true };
      if (this.white) return { white: true };
      if (this.red) return { red: true };
    },
    leadProps() {
      if (this.leadTight) return { leadTight: true };
      if (this.leadRegular || (!this.leadTight && !this.leadLoose)) return { leadRegular: true };
      if (this.leadLoose) return { leadLoose: true };
    },
    primaryProps() {
      if (this.large) return { sizeLg: true };
      if (this.regular) return { sizeBase: true };
      if (this.small) return { sizeSm: true };
      if (this.micro) return { sizeXs: true, bold: true, uppercase: true };
    },
    variantProps() {
      return {
        bold: this.bold,
        center: this.center,
        ellipsis: this.ellipsis,
        italic: this.italic,
        medium: this.medium,
        underline: this.underline,
        uppercase: this.uppercase,
      };
    },
  },
};
</script>
